<script setup>
import { defineEmits, defineProps, ref } from "vue";
import {useNewsFeedStore} from "@/store/NewsFeed/newsFeed";
import { t } from "@/controllerLK/GlobusLocalization";

const props = defineProps({
  title: {
    type: String,
    default: ""
  }
});

const emit = defineEmits(["close"]);

const newsFeedStore = useNewsFeedStore();

const activeCategoryId = ref(newsFeedStore.currentNews.category_id);

const saveCategory = async () => {
  await newsFeedStore.updateCardCategory(newsFeedStore.currentNews.id, activeCategoryId.value);
  emit("close");
};

const isFormSubmitted = ref(false);
</script>

<template>
  <Sidebar
    :title="props.title"
    :use-cross-icon="true"
    :use-cancel="false"
    :is-confirm-pressed="isFormSubmitted"
    :confirm-text="t('news_page_popup_sidebar.button')"
    teleport="#app"
    @close="emit('close')"
    @confirm="saveCategory"
  >
    <div class="category-switcher-list">
      <div
        v-for="category in newsFeedStore.filterCategories.list"
        :key="category.id"
        class="category-switcher-list__item"
        :class="{'category-switcher-list__item_active': category.id === activeCategoryId}"
        @click="activeCategoryId = category.id"
      >
        <RadioButton
          :model-value="activeCategoryId === category.id"
          :label="category.name"
          :readonly="true"
        />
      </div>
    </div>
  </Sidebar>
</template>

<style scoped lang="scss">
.category-switcher-list {
  display: flex;
  flex-direction: column;
  gap: 10px;

  &__item {
    display: flex;
    align-items: center;
    gap: 10px;
    border-radius: 8px;
    padding: 0 14px;
    height: 30px;
    cursor: pointer;
    color: #373D3F;

    &:hover {
      background: #EEF1F4;

      &:deep(input) {
        border-color: var(--icon-icon-on);
      }

    }

    &_active {
      color: #1F9AFF;

      &:hover {
        background: #E0F0FF;
      }
    }
  }
}
</style>